// Identity accepted email validator
const regexLiteral = /([a-z0-9._%\-+!#$&/=?^|~ ]+)@([a-z0-9 -]+\.)+ *[a-z]+/;
export const emailRegex = new RegExp(regexLiteral);
